var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7694 21.1223C12.8126 21.7163 10.7167 21.6654 8.79116 20.977C6.86558 20.2887 5.21236 18.9994 4.07559 17.2996C2.93882 15.5998 2.37874 13.5795 2.47805 11.537C2.57736 9.49452 3.3308 7.53809 4.62712 5.95657C5.92344 4.37505 7.69394 3.25227 9.67721 2.75401C11.6605 2.25574 13.7514 2.40839 15.6413 3.18942",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12,
    r: 9.53333,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2828c527918c47f170f5fd2cdc32f8ba.svg";
export { ForwardRef as ReactComponent };